// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--R0CQd","input":"input--qNoiF"};